import { render, staticRenderFns } from "./EmployeeTimeCard.vue?vue&type=template&id=1b18e70a&"
import script from "./EmployeeTimeCard.vue?vue&type=script&lang=js&"
export * from "./EmployeeTimeCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports